import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import './BotaoNaoEncontrou.css';

function BotaoNaoEncontrou({ termoBusca, className = '' }) {
  const navigate = useNavigate();

  const handleClick = () => {
    const url = termoBusca 
      ? `/perfil?tab=enviar&termo=${encodeURIComponent(termoBusca)}`
      : '/perfil?tab=enviar';
    navigate(url);
  };

  return (
    <div className="nao-encontrou-wide">
      <span className="nao-encontrou-texto">Não encontrou o que procura?</span>
      <button onClick={handleClick} className="nao-encontrou-btn">
        <FaArrowRight /> Enviar Pergunta/Material
      </button>
    </div>
  );
}

export default BotaoNaoEncontrou;